<template>
  <b-row class="dashboard-indicadores-historico-plazos">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresPlazosProveedores" 
          :fields="indicadoresPlazosProveedoresFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(plazoObjetivo)="data">
          {{ data.item.plazoObjetivo }}
          <!-- {{ data.item.plazoObjetivo | numero(2, true) }} -->
        </template>
        <template v-slot:cell(plazoActual)="data">
          {{ data.item.plazoActual }}
          <!-- {{ data.item.plazoActual | numero(2, true) }} -->
        </template>
        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarComprobantes(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Comprobantes</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    semestral: {
      type: Boolean,
      default: true
    },
    showTitulo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      indicadoresPlazosProveedores: [],
      indicadoresPlazosProveedoresFields: [
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'plazoObjetivo',
          class: 'text-right'
        },
        { 
          key: 'plazoActual',
          label: 'Plazo Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false
    }
  },
  computed: {
    titulo() {
      if ((/true/i).test(this.totalNegocio)) {
        return `Plazos de Pago - ${this.semestral? 'Semestral' : 'Anual'}`;
      }
      return `Plazos de Pago - ${this.semestral? 'Semestral' : 'Anual'}`;
    }
  },
  methods: {
    getIndicadores() {
      let dispatch = 'resultadosAdministracion/getIndicadoresPlazosProveedoresHistorico';
      let getter = 'resultadosAdministracion/indicadoresPlazosProveedoresHistorico';

      if (!(/true/i).test(this.semestral)) {
        dispatch = 'resultadosAdministracion/getIndicadoresPlazosProveedoresAnualHistorico';
        getter = 'resultadosAdministracion/indicadoresPlazosProveedoresAnualHistorico';
      }

      this.tableBusy = true;
      this.$store.dispatch(dispatch)
        .then(() => {
          this.indicadoresPlazosProveedores = this.$store.getters[getter];
          this.tableBusy = false;
        });
    },
    exportarComprobantes(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosProveedoresHistoricoComprobantes', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosAdministracion/resultadosIndicadorPlazosProveedoresComprobantes'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSResumenPlazosProveedores(rptComprobantes);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  }
}
</script>

<style>
  .dashboard-indicadores-historico-plazos .registro table td[aria-colindex="1"] {
    width: calc(50% - 30px) !important;
  }
  .dashboard-indicadores-historico-plazos .registro table td[aria-colindex="2"],
  .dashboard-indicadores-historico-plazos .registro table td[aria-colindex="3"] {
    width: 10% !important;
  }
  .dashboard-indicadores-historico-plazos .registro table td[aria-colindex="4"] {
    width: 30% !important;
  }
  .dashboard-indicadores-historico-plazos .registro table td[aria-colindex="5"] {
    width: 30px !important;
  }

</style>